import { GridItemChangeEvent } from '@progress/kendo-react-grid'
import { cloneDeep } from 'lodash'
import { FixMeLater } from 'types';


export const enterEdit = (datasource: FixMeLater, id: FixMeLater, status: boolean) => {
  const cloneDataSource = cloneDeep(datasource.data);
  const updatedDataSource = cloneDataSource.map((cloneRole: FixMeLater) =>
    cloneRole._id === id ? { ...cloneRole, inEdit: status } : cloneRole,
  );
  return { ...datasource, data: updatedDataSource };
}

export const discard = (datasource:FixMeLater) => ({
  ...datasource,
  data: Array.isArray(datasource.data) ? datasource.data.filter((item: { inEdit: FixMeLater; }) => !item.inEdit) : datasource.data,
});

export const itemChange = (datasource: FixMeLater, e: GridItemChangeEvent) => {
  if (!datasource || !datasource.data || !Array.isArray(datasource.data)) {
    return [];
  }
  const updatedData = datasource.data.map((item: FixMeLater) =>
    item._id === e.dataItem._id ? { ...item, [e.field ?? '']: e.value } : item,
  );
  return { ...datasource, data: updatedData };
}


export const addNew = (datasource: FixMeLater) => {
  const newDataItem = { inEdit: true };
  if (Array.isArray(datasource.data)) {
    const updatedData = [newDataItem, ...datasource.data];
    return { ...datasource, data: updatedData };
  } else {
    //console.error('datasource.data bir dizi değil:', datasource);
    return datasource;
  }
};



export const addChange = (datasource: FixMeLater, insertedId: string) => {
  const cloneDataSource = cloneDeep(datasource)
  const newsource = cloneDataSource.map((item: FixMeLater) => {
    return !item._id ? { ...item, _id: insertedId } : item
  })

  return newsource
}
